import State from './State';

class FFASelectState extends State {}

export default FFASelectState;



// WEBPACK FOOTER //
// ./src/game/states/FFASelectState.ts